import Icon from './Icon';

export default function BtnThumbs ({ type, text, disabled, tabIndex, animating, _action })
{

  let btnStyle = '';
  let btnIcon = '';

  switch( type ) {
    default:
    case 'down':
      btnStyle = 'cancel-button';
      btnIcon  = 'material-symbols:arrow-back-ios-rounded';
      break;

    case 'up':
      btnStyle = 'confirm-button inverted';
      btnIcon = 'material-symbols:thumb-up';
      break;

    case 'check':
      btnStyle = 'confirm-button inverted';
      btnIcon = 'material-symbols:check-circle-outline-rounded';
      break;

    case 'refresh':
      btnStyle = 'confirm-button inverted';
      btnIcon = 'material-symbols:refresh-rounded';
      break;

  }

  return (
    <button
        type       = "button"
        className  = { `${btnStyle} ${ animating ? 'animating' : ''}` }
        onClick    = { _action }
        disabled   = { disabled }
        tabIndex   = { tabIndex } >

        <div className="btn-content">
            { animating
                ? <span className="spinner" />
                : < Icon icon = { btnIcon } _style="btn-icon-small" />
            }
        </div>

        <div className='btn-text'>
            { text }
        </div>
    </button>

  )
}
